import { atom } from 'recoil';

export const SnackbarAtom = atom({
  key: 'Snackbar',
  default: null,
});
